import { contractsLocale } from 'modules/contracts/presentation/locale';
import contractsRoutes from 'modules/contracts/presentation/routes';

const contractsModule = {
  routes: contractsRoutes,
  locale: contractsLocale,
};

export default contractsModule;
